const Resources = {

    table_headers: [
        { 
          text: 'Description',  
          align: 'start', 
          value: 'description',
          type:  'link',
          event: true,
        },
        { 
            text: 'Include in days off',
            value: 'include_days_off',
            type:   'boolean',
        },
        { 
            text: 'Include in assignment',
            value: 'include_assignment',
            type:   'boolean',
        },
        {   
            text: 'Include in census',
            value: 'include_census',
            type:   'boolean',
        },
        {   
            text: 'Include in Q.C',
            value: 'include_qc',
            type:   'boolean',
        },
        {   
            text: 'Associate counter',
            value: 'associate_counter', 
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Associates',
            href:   '/associates',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Contact Types',
            href:   '/associate-contract-types',
            arrow:  " ",
        },
    ],

    excel_file_headers: {
        'Description': 'description',
        'Include in days off': 'include_days_off',
        'Include in census': 'include_census',
        'Include in assignment': 'include_assignment',
        'Include in Q.C.': 'include_qc',
    },

    empty_format_data: [
        {
            description:            '',
            include_days_off:       true,
            include_census:         true,
            include_assignment:     true,
            include_qc:             true,
        },
    ],
    
    excel_fields_required: {
        description:            '',
        include_days_off:       false,
        include_census:         false,
        include_assignment:     false,
        include_qc:             false,
    },

    helps: [
        {
            label: '¿How to add a Contact Type?', 
            instruction: `https://scribehow.com/embed/How_to_Add_a_Contact_Type__zPeSrslYQaS1FATnqUzV7Q?as=scrollable`
        },
    ],

}

export default Resources;